import React from 'react'

const ManagePayments = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Manage Payments</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">System Admin</li>
            <li className="breadcrumb-item active">Manage Payments</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="bi bi-credit-card me-2" />
                  Payment Configuration
                </h5>
                <p className="text-muted">
                  This is a placeholder screen for managing payment settings and subscriptions. Configure gateways and billing here later.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ManagePayments

